import "date-fns";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { withStyles } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
const style = () => ({
  dateSelectorContainer: {
    display: "block",
    borderColor: brandTheme.black,
    '& .Mui-disabled':{
      color:brandTheme.fieldColor,
    },
    "& .MuiFormControl-marginNormal": {
      width: "100%",
      marginTop: "0px",
    },
    '& .MuiFormLabel-root.Mui-error':{
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      color:brandTheme.black,
      fontSize:'15px',
      "@media (max-width:768px)":{
          fontSize:'13px',
        },
    },
    "& .MuiFilledInput-adornedEnd": {
      backgroundColor: brandTheme.white,
      paddingRight: "0px !important",
      "&:before": {
        borderBottom: "inherit",
      },
      "&:after": {
        borderBottom: "inherit",
      },
      "& .MuiFormLabel-root.Mui-focused": {
        color:brandTheme.black,
      },
      "& .MuiInputAdornment-positionEnd": {
        position: "absolute",
        right: 20,
        "& button": {
          "&:hover": {
            backgroundColor: "inherit",
          },
        },
      },
      "& input": {
        padding: "0px 10px",
        borderRadius: "5px",
        border: "1px solid gray",
        height: "37px",
      },
    },
  },
  errorDate:{
    display:'block',
    "& input": {
      border: "1px solid red !important",
    },
  }
});
const CustomeDateCalender = ({ ...props }) => {
  const { handleDateChange, selectedDate, id, classes, inputProps,label,error } = props;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid
        container
        justifyContent="space-around"
        className={error? `${classes.errorDate} ${classes.dateSelectorContainer}`: classes.dateSelectorContainer}
      >
        <KeyboardDatePicker
          inputVariant={"filled"} 
          disableToolbar
          variant="inline"
          format="dd/MM/yyyy"
          margin="normal"
          label={label}
          // size="small"
          id={id}
          style={{
            width: "100%",
          }}
          views={["year", "month", "date"]}
          value={selectedDate}
          onChange={handleDateChange}
          autoOk={true}
          {...inputProps}
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
          InputLabelProps={{ shrink: true }} 
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export default withStyles(style)(CustomeDateCalender);
